// ======================================================================
// File Name       : DistributionReportSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import PaginationCustom from '../../Pagination';
import RenderField from '../../../utils/ReduxFormUtils';
import { REPORT_STATUS_SUBMITTED } from '../../../constants/KeyValueConstants';
import * as unsubmittedReportAction from '../../../actions/report/UnsubmittedReportAction';
import SelectGroupDlg from '../../../components/group/SelectUserGroupDialog';
import { convertNodeGroupToNodeString } from '../../../utils/UserUtils';
import CustomButton from '../../button/CustomButton';

class UnsubmittedReportSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSelectGroup: false,
    };
    this.searchData = this.searchData.bind(this);
    this.onSearchData = this.onSearchData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.deleteSelectedGroup = this.deleteSelectedGroup.bind(this);
  }

  searchData() {
    this.props.updateShowSearchMessageFlag(false);
    const { dispatch, unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo } = unsubmittedReportList;
    searchInfo.startPosition = 0;
    dispatch(unsubmittedReportAction.updateUnsubmittedReportSearchInfo(searchInfo));
    dispatch(unsubmittedReportAction.searchUnsubmittedReport()).then(() => {
      this.props.updateShowSearchMessageFlag(true);
    });
  }
  /**
   * Get Unsubmitted report list when click button search
   */
  onSearchData() {
    const { dispatch } = this.props;
    dispatch(unsubmittedReportAction.searchUnsubmittedReport());
  }

  /**
     * Pagination
     * @param {*} startPosition
     */
  getStartEndData(startPosition) {
    const { dispatch, unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo } = unsubmittedReportList;
    searchInfo.startPosition = startPosition;
    dispatch(unsubmittedReportAction.updateUnsubmittedReportSearchInfo(searchInfo));
    dispatch(unsubmittedReportAction.searchUnsubmittedReport());
  }

  /**
   * Show select group dialog
   */
  showSelectGroupDlg() {
    this.setState({ showSelectGroup: true });
  }

  /**
   * Handle event when click on キャンセル of select group dialog
   */
  cancelSelectGroupDlg() {
    this.setState({ showSelectGroup: false });
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   * @param {object} group
   */
  okSelectGroupDlg(group) {
    const { dispatch, unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo } = unsubmittedReportList;
    searchInfo.selectedGroup = {};
    if (group) {
      searchInfo.selectedGroup = group;
      searchInfo.groupName = group.groupName;
      if (searchInfo.selectedGroup && unsubmittedReportList.groupList && searchInfo.selectedGroup.groupSecernId) {
        const groupSecernId = searchInfo.selectedGroup.groupSecernId;
        searchInfo.groupName = convertNodeGroupToNodeString(groupSecernId, unsubmittedReportList.groupList);
      }
    }
    dispatch(unsubmittedReportAction.updateUnsubmittedReportSearchInfo(searchInfo));
    this.setState({ showSelectGroup: false });
  }

  deleteSelectedGroup() {
    const { dispatch, unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo } = unsubmittedReportList;
    searchInfo.selectedGroup = null;
    searchInfo.groupName = null;
    dispatch(unsubmittedReportAction.updateUnsubmittedReportSearchInfo(searchInfo));
    this.setState({ showSelectGroup: false });
  }

  render() {
    const { dispatch, unsubmittedReport, formValues } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo, recordNum, groupList } = unsubmittedReportList;
    const { startPosition, selectedGroup, groupName } = searchInfo;
    const { showSelectGroup } = this.state;
    let disabledButtonSearch = true;
    if ((formValues && (formValues.reportName || formValues.userName))
    || (selectedGroup && selectedGroup.groupSecernId)) {
      disabledButtonSearch = false;
    }
    return (
      <div>
        <p className="margin-top-10">検索する項目を指定してください</p>
        <Col sm={12} className="padding-top-10">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.searchData();
            }}
            className='form-horizontal'
          >
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                レポート名
              </Col>
              <Col sm={8} className="padding-right-15">
                <RenderField type="text" name="reportName" label="レポート名" maxLength="256" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info" controlId="formHorizontalUserName">
              <Col as={Form.Label} sm={4}>
                ユーザー名(提出者)
              </Col>
              <Col sm={8} className="padding-right-15">
                <RenderField type="text" name="userName" label="ユーザー名(提出者)" maxLength="40" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                所属グループ(提出者)
              </Col>
              <Col sm={5}>
                <Button variant="primary" className="btn-96" onClick={this.showSelectGroupDlg}>
                  グループ選択
                </Button>
              </Col>
            </Form.Group>
            {searchInfo && searchInfo.groupName ? (
              <Form.Group className="form-info" controlId="formHorizontalGroup">
                <Col sm={4}>
                </Col>
                <Col sm={6} as={Form.Label} className="padding-left-clear">
                  {groupName}
                </Col>
                <Col sm={2}>
                  <Button variant="primary" className="btn-96 margin-left-15" onClick={this.deleteSelectedGroup}>
                    削除
                  </Button>
                </Col>
              </Form.Group>
            ) : null}
            <Form.Group className="form-info">
              <Col htmlFor="includeDeadlineReportFlg" as={Form.Label} sm={4}>
                提出期限切れレポートを含む
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  type="checkbox"
                  name="includeDeadlineReportFlg"
                  className="padding-top-clear"
                />
              </Col>
            </Form.Group>
            <Form.Group className="margin-top-20 text-center form-group">
              <Col sm={12}>
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  type="submit"
                  text="検索"
                  iconClass="bi bi-search"
                  isDisabled={disabledButtonSearch}
                />
              </Col>
            </Form.Group>
          </Form>
        </Col>
        {this.props.isShowList &&
          <Col sm={12} className="padding-left-right-clear">
            <Form className='form-horizontal'>
              <Col sm={5} className="padding-left-right-clear margin-top-30 margin-bottom-20">
                未提出レポート一覧
              </Col>
            </Form>
          </Col>
        }
        <SelectGroupDlg
          showModal={showSelectGroup}
          selectedGroup={selectedGroup}
          groupList={groupList}
          onCancel={this.cancelSelectGroupDlg}
          onOK={this.okSelectGroupDlg}
        />
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { unsubmittedReport } = state;
  const data = {
    includeDeadlineReportFlg: false,
    reportName: '',
    userName: '',
  };
  return {
    initialValues: data,
    formValues: getFormValues('unsubmittedReportSearchForm')(state),
    unsubmittedReport,
  };
};

const form = reduxForm({ form: 'unsubmittedReportSearchForm', touchOnChange: true });
export default connect(mapStateToProps)(form(UnsubmittedReportSearch));
